import React, { memo, useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { createSelector } from 'reselect';
import { message } from 'antd';
import { debounce } from 'lodash-es';
import cssVars from 'css-vars-ponyfill';

import {
  setMenuSpot,
  setIsEnabledSilent,
  setCanBack,
  setDownloadVisible,
  setHotLenovoVisible,
  setOperationMenuVisible,
  setTopImgVideoVisible,
  setMaximize,
  setActiveMenu,
  setFirstRun,
  setDownloadPathVisible,
  setMessageVisible,
  changeWindowSize,
} from '../actions/layout';

import { getPayGamePayList, getSubscribedAppList, emptySubscribedAppList } from '../actions/native';
import { getSoftInfosByVersion } from '../actions/recommend';
import { getEducationCategoryTags } from '../actions/education';
import { getEducationNewTabs } from '../actions/education';
import { showAAppQRCode } from '../actions/adetail';
import { logPostInfo, logging } from '../actions/log';
import { updateIsVTEabled } from '../actions/asimstatus';
import { setIsSearchClick } from '../actions/search';
import { downloadAddSoftList } from '../actions/downloadTask';
import { createShortcut } from '../actions/layout';

import NoNet from '../components/NoNet/NoNet';
import { CONTEXT, MICROCONTEXT } from '../config';
import { MENUS_CAN_BACK } from '../constants/layout';
import { cacheKeys, mySoftKeys, SCROLL_PAGE } from '../constants/storageKeys';
import { PCStoreJsBridge } from '../nativeapi';
import Setting from './Setting/Setting';
import Menu from './Menu';
import Operation from './Operation';
import PinPop from './PinPop/PinPop';
import PinPopClose from './PinPop/PinPopClose';
import PinPopToDStore from './PinPop/PinPopToDStore';
import PinPopTray from './PinPop/PinPopTray';
import SIMPop from './SIMPop'; // 模拟器下载弹窗
import SimPopup from '../components/SimPopup/SimPopup'; // 模拟器是否下载选择弹窗
import InstDonePop from './InstDonePop';
import Search from './Search/Search';
import WpPreview from './WpPreview';
import Iframe from './Iframe';
import DetailCommentDialog from './DetailCommentDialog';
import {
  changeClass,
  getParamString,
  getParamString2,
  getParamString3,
  hasClass,
  logNative,
  getDefaultPage,
  localGetItem,
  localSetItem,
} from '../utils/utils';
import { SIM_PREPARING, SIM_STATUS_POP_SHOW } from '../constants/asimstatus';
import { updatePreviewInfo, updateWpPayDownCount, removeDownloadImg } from '../actions/wallpaper';
import { WP_DOWNLOAD_FINISHED, WP_DOWNLOAD_FAILED } from '../constants/wallpaper';
import success from '../static/msg-success.svg';
import fail from '../static/msg-fail.svg';
import UserScore from './UserScore';
import FasterProduct from '../components/FasterProduct/FasterProduct';
import About from './OperationMenu/About';
import DownloadTask from './OperationMenu/DownloadTask';
import PhoneQRcode from './OperationMenu/PhoneQRcode';
import OperationMenu from './OperationMenu/OperationMenu';
import CheckUpdate from './OperationMenu/CheckUpdate';
import ReleaseNotes from './OperationMenu/ReleaseNotes';
import UserFeedback from './OperationMenu/UserFeedback';
import Share from './OperationMenu/Share';
import Message from './OperationMenu/Message';
import DownloadFile from './OperationMenu/DownloadFile';
import DownloadSIM from './OperationMenu/DownloadSIM';

import styles from './Layout.module.less';
import stylesLoading from '../components/Loading/Loading.module.less';
import Welcome from '../pages/Welcome/Welcome';
import DEFAULTTHEME from '../utils/theme/default';
import LIGHTTHEME from '../utils/theme/light';
import UserSurvey from './UserSurvey';
import Toast from '../components/Toast/Toast';
import WallpaperShortcut from './WallpaperShortcut';

import ButtonPayAntiInfo from './ButtonPay/ButtonPayAntiInfo';
import ButtonPayOrder from './ButtonPay/ButtonPayOrder';
import ButtonPayAnti from './ButtonPay/ButtonPayAnti';
import WpTurnIndex from './Wallpaper/WpTurnIndex';
import SubscribeSuccess from '../components/SubscribeSuccess/SubscribeSuccess';
import SubscribeCancel from '../components/SubscribeCancel/SubscribeCancel';
import NoLoginSubscribe from '../components/NoLoginSubscribe/NoLoginSubscribe';
import SoftOpenFail from '../components/SoftOpenFail/SoftOpenFail';
import WpExchange from './Wallpaper/WpExchange';
import WpExchangeResult from './Wallpaper/WpExchangeResult';
import CancelDownload from './OperationMenu/DownloadCancel';
import Gamecdk from './Gamecdk/Gamecdk';
import GamecdkShow from './Gamecdk/GamecdkShow';
import AIGC from './AIGC/AIGC';
import AIGCInit from './AIGC/AIGCInit';

const selectCommandLine = createSelector(
  state => state.native,
  native => native.commandLine,
);

const selectNetStatus = createSelector(
  state => state.network,
  network => network.online,
);

const selectInTimeInstSoft = createSelector(
  state => state.layout,
  layout => layout.inTimeInstSoft,
);

const selectDownloadVisible = createSelector(
  state => state.layout,
  layout => layout.downloadVisible,
);

const selectOperationMenuVisible = createSelector(
  state => state.layout,
  layout => layout.OperationMenuVisible,
);

const selectAboutVisible = createSelector(
  state => state.layout,
  layout => layout.AboutVisible,
);

const selectPinPopVisible = createSelector(
  state => state.layout,
  layout => layout.pinPopVisible,
);

const selectPinPopCloseVisible = createSelector(
  state => state.layout,
  layout => layout.pinPopCloseVisible,
);

const selectCanBack = createSelector(
  state => state.layout,
  layout => layout.canback,
);

const selectDownloadPathVisible = createSelector(
  state => state.layout,
  layout => layout.downloadPathVisible,
);
// 独立包-检查更新
const selectCheckUpdate = createSelector(
  state => state.layout,
  layout => layout.checkUpdateVisible,
);

const selectPhoneVisible = createSelector(
  state => state.layout,
  layout => layout.phoneVisible,
);

const selectSIMStatus = createSelector(
  state => state.asimstatus,
  asimstatus => asimstatus.status,
);
const selectSIMPopupInfo = createSelector(
  state => state.asimstatus,
  asimstatus => asimstatus.SIMPopupInfo,
);

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

const selectUninstallSoft = createSelector(
  state => state.native,
  native => native.uninstallSoft,
);

const selectDownloadSofts = createSelector(
  state => state.downloadTask,
  downloadTask => downloadTask.softs,
);

const selectDownload = createSelector(
  state => state.downloadTask,
  downloadTask => downloadTask,
);

const selectInstalledSoft = createSelector(
  state => state.native,
  native => native.installedSoft,
);

const selectWpPreview = createSelector(
  state => state.wallpaper,
  wallpaper => wallpaper.wpPreviewInfo,
);

const selectDownloadImgs = createSelector(
  state => state.wallpaper,
  wallpaper => ({
    wpDowloadImgs: wallpaper.wpDowloadImgs,
    wpPayDownCount: wallpaper.wpPayDownCount,
  }),
);

const selectIframeInfo = createSelector(
  state => state.layout,
  layout => layout.iframeInfo,
);

const selectDetailCommentInfo = createSelector(
  state => state.layout,
  layout => layout.detailCommentInfo,
);

const selectReleaseNotesVisible = createSelector(
  state => state.layout,
  layout => layout.releaseNotesVisible,
);

const selectUserFeedbackVisible = createSelector(
  state => state.layout,
  layout => layout.userFeedbackVisible,
);

const selectTopImgVideoVisible = createSelector(
  state => state.layout,
  layout => layout.topImgVideo,
);

const selectShareVisible = createSelector(
  state => state.layout,
  layout => layout.shareVisible,
);

const selectFasterProductVisible = createSelector(
  state => state.layout,
  layout => layout.fasterProduct,
);

const selectIsMaximize = createSelector(
  state => state.layout,
  layout => layout.isMaximize,
);

const selectMessageVisible = createSelector(
  state => state.layout,
  layout => layout.messageVisible,
);

const selectWelcomeData = createSelector(
  state => state.welcome,
  welcome => welcome.welcomeData,
);
const selectWelcomeInit = createSelector(
  state => state.welcome,
  welcome => welcome.init,
);
const selectFirstRun = createSelector(
  state => state.layout,
  layout => layout.firstRun,
);
const selectStoreTheme = createSelector(
  state => state.layout,
  layout => layout.storeTheme,
);
const SelectEductionCategory = createSelector(
  state => state.education,
  educations => educations.category,
);

const SelectWallpaper = createSelector(
  state => state.layout,
  layout => layout.wallpaperShortcut,
);

const SelectCreateShortcut = createSelector(
  state => state.layout,
  layout => layout.wallpaperShortcut,
);
const selectCleanToDStore = createSelector(
  state => state.layout,
  layout => layout.cleanToDStore,
);

const selectSoftInfosVersion = createSelector(
  state => state.recommend,
  recommend => recommend.softInfosVersion,
);
const selectUpgradeSofts = createSelector(
  state => state.native,
  native => native.upgradeSofts,
);
const selectSilentInstSoft = createSelector(
  state => state.native,
  native => native.supportSilentInstSoft,
);
const selectUserInfo = createSelector(
  state => state.user,
  user => user.userInfo,
);

const selectButtonPay = createSelector(
  state => state.buttonpay,
  buttonpay => buttonpay,
);

const selectSubscribeSucc = createSelector(
  state => state.layout,
  layout => layout.subscribeSuccShow,
);

const selectCancelShow = createSelector(
  state => state.layout,
  layout => layout.subscribeCancellationShow,
);

const selectNologinSubscribeShow = createSelector(
  state => state.layout,
  layout => layout.noLoginSubscribe,
);

const selectOpenFailSoft = createSelector(
  state => state.layout,
  layout => layout.openFailSoftInfo,
);

const selectWpExchange = createSelector(
  state => state.wallpaperPay,
  wallpaperPay => wallpaperPay.exchangeShow,
);

const selectWpExchangeResult = createSelector(
  state => state.wallpaperPay,
  wallpaperPay => wallpaperPay.exchangeResult,
);

const selectCanelDownload = createSelector(
  state => state.downloadTask,
  downloadTask => downloadTask.downloadCanelShow,
);

const selectAIGC = createSelector(
  state => state.aigc,
  aigc => aigc.showDialog,
);

const selectLayout = createSelector(
  state => state.layout,
  layout => layout,
);

const selectGameCDK = createSelector(
  state => state.gamecdk,
  gamecdk => gamecdk,
);
function Index({ children }) {
  const dispatch = useDispatch();
  const commandLine = useSelector(selectCommandLine);
  const history = useHistory();
  const location = useLocation();
  const containerRef = useRef(null);
  const imgVideoRef = useRef(null);

  const { btnPayOrder, btnPayAnti, btnPayAntiErr } = useSelector(selectButtonPay);
  const userInfo = useSelector(selectUserInfo);
  const firstRun = useSelector(selectFirstRun);
  const inTimeInstSoft = useSelector(selectInTimeInstSoft);
  const downloadVisible = useSelector(selectDownloadVisible);
  const OperationMenuVisible = useSelector(selectOperationMenuVisible);
  const AboutVisible = useSelector(selectAboutVisible);
  const checkUpdateVisible = useSelector(selectCheckUpdate); // 独立包-检查更新
  const pinPopVisible = useSelector(selectPinPopVisible);
  const pinPopCloseVisible = useSelector(selectPinPopCloseVisible);
  const downloadPathVisible = useSelector(selectDownloadPathVisible);
  const phoneVisible = useSelector(selectPhoneVisible);
  const canBack = useSelector(selectCanBack);
  const logInfoData = useSelector(selectLogInfo);
  const SIMStatus = useSelector(selectSIMStatus); // 模拟器状态
  const uninstallSoft = useSelector(selectUninstallSoft); // 正处在卸载中的应用
  const downloadSoftDatas = useSelector(selectDownloadSofts); // 正处在下载安装中的应用
  const { showFileError, showSIM } = useSelector(selectDownload); // 下载任务
  const online = useSelector(selectNetStatus);
  const installedSoft = useSelector(selectInstalledSoft); // 本地应用
  const iframeInfo = useSelector(selectIframeInfo); // 展示iframe
  const detailCommentInfo = useSelector(selectDetailCommentInfo); // 展示弹框评论
  const cleanToDStore = useSelector(selectCleanToDStore); // 是否弹出将集成包洗成独立包弹框

  const wpPreview = useSelector(selectWpPreview); // 全屏预览壁纸
  // 正在处理中的壁纸
  const { wpDowloadImgs, wpPayDownCount } = useSelector(selectDownloadImgs);

  const SIMPopupInfo = useSelector(selectSIMPopupInfo); //

  const releaseNotesVisible = useSelector(selectReleaseNotesVisible); // 更新日志
  const userFeedbackVisible = useSelector(selectUserFeedbackVisible); // 我要反馈
  const topImgVideo = useSelector(selectTopImgVideoVisible); // 头部图片视频
  const shareVisible = useSelector(selectShareVisible);
  const fasterProductVisible = useSelector(selectFasterProductVisible); // 加速器弹窗
  const isMaximize = useSelector(selectIsMaximize); // 是否全屏
  const messageVisible = useSelector(selectMessageVisible); // 消息中心
  const storeTheme = useSelector(selectStoreTheme); // 商店主题

  const [userScoreVisible, setUserScoreVisible] = useState(false);

  const welcomeData = useSelector(selectWelcomeData);
  const welcomeInit = useSelector(selectWelcomeInit);
  const [welcome, setWelcome] = useState(false); // 判断欢迎页是否被弹出
  const [welcomeLoadImg, setWelcomeLoadImg] = useState(false); // 判断欢迎页是否被弹出
  const cachEL = useRef(null);
  const [theme, setTheme] = useState(DEFAULTTHEME);
  const [isChooseWelcome, setIsChooseWelcome] = useState(null);
  const { tags, gradeList = [], pagenation, error } = useSelector(SelectEductionCategory);
  const wallpaperInfo = useSelector(SelectWallpaper);

  const upgradeSofts = useSelector(selectUpgradeSofts); // 8.3 可更新的软件
  const softInfosVersion = useSelector(selectSoftInfosVersion); // 8.3
  const silentInstSoft = useSelector(selectSilentInstSoft); // 8.3 支持快速静默安装的应用列表
  const subscribeSuccVisible = useSelector(selectSubscribeSucc); // 8.7 预约成功弹窗
  const cancelShow = useSelector(selectCancelShow); // 8.7 取消预约弹框
  const noLoginSub = useSelector(selectNologinSubscribeShow); // 8.7 有包预约未登录弹窗
  const openFailSoft = useSelector(selectOpenFailSoft); // 8.8打开应用失败弹窗
  const wpExchangeShow = useSelector(selectWpExchange); //9.0壁纸兑换码弹窗
  const wpExchangeResult = useSelector(selectWpExchangeResult); // 9.0壁纸兑换码结果弹窗
  const canenlDownShow = useSelector(selectCanelDownload); // 9.0删除准备中的下载程序
  const selectAIGCShow = useSelector(selectAIGC); // 9.0删除准备中的下载程序
  // 9.0.11 游戏CDK购买弹框   9.0.11 托盘创建弹框
  const { storeTrayVisiable } = useSelector(selectLayout);
  const { gamecdkVisible, gamecdkCodeShow } = useSelector(selectGameCDK);

  let AllStoreTheme = {
    1: DEFAULTTHEME,
    3: LIGHTTHEME,
  };

  // 启动事项  调用C++页面，让其展示出页面
  useEffect(() => {
    if (window?.external?.h5_data_load_complete) {
      window.external.h5_data_load_complete();
      dispatch(
        logging({
          category: 'R',
          action: 'PCSTORE_Notice_ShowPage',
          param2: {
            source: 'PCSTORE_Notice_ShowPage',
            PCStoreNoticeShowPage: +new Date(), // 通知客户端显示页面
            PCStoreStartBegin: window.PC_STORE_START_BEGIN, // 点击启动商店时间点
            PCStoreHtmlLoadEnd: window.PC_STORE_START_HTML_LOAD_END, // html下载完成时间点
            PCStoreJsLoadEnd: window.PC_STORE_START_JS_LOAD_END, // JS css下载完成时间点
            startToHtmlLoad: window.PC_STORE_START_HTML_LOAD_END - window.PC_STORE_START_BEGIN, // 从点击启动 到 html下载完成所用时间
            jsLoadTime: window.PC_STORE_START_JS_LOAD_END - window.PC_STORE_START_HTML_LOAD_END, // JS下载完成所用时间
            startToJsLoadTime: window.PC_STORE_START_JS_LOAD_END - window.PC_STORE_START_BEGIN, // 从点击启动 到 JS下载完成所用时间
          },
        }),
      );
    }
    setTimeout(() => {
      let param2 = {
        source: 'PCSTORE_Performance',
        ...window?.performance?.timing,
        // 在同一个浏览器上下文中，前一个网页（与当前页面不一定同域）unload 的时间戳，
        // 如果无前一个网页 unload ，则与 fetchStart 值相等
        navigationStart: window?.performance?.timing?.navigationStart,
        // 前一个网页（与当前页面同域）unload 的时间戳，如果无前一个网页 unload
        // 或者前一个网页与当前页面不同域，则值为 0
        unloadEventStart: window?.performance?.timing?.unloadEventStart,
        // 和 unloadEventStart 相对应，返回前一个网页 unload 事件绑定的回调函数执行完毕的时间戳
        unloadEventEnd: window?.performance?.timing?.unloadEventEnd,
        // 第一个 HTTP 重定向发生时的时间。有跳转且是同域名内的重定向才算，否则值为 0
        redirectStart: window?.performance?.timing?.redirectStart,
        // 最后一个 HTTP 重定向完成时的时间。有跳转且是同域名内部的重定向才算，否则值为 0
        redirectEnd: window?.performance?.timing?.redirectEnd,
        // 浏览器准备好使用 HTTP 请求抓取文档的时间，这发生在检查本地缓存之前
        fetchStart: window?.performance?.timing?.fetchStart,
        // DNS 域名查询开始的时间，如果使用了本地缓存（即无 DNS 查询）或持久连接，则与 fetchStart 值相等
        domainLookupStart: window?.performance?.timing?.domainLookupStart,
        // DNS 域名查询完成的时间，如果使用了本地缓存（即无 DNS 查询）或持久连接，则与 fetchStart 值相等
        domainLookupEnd: window?.performance?.timing?.domainLookupEnd,
        // HTTP（TCP） 开始建立连接的时间，如果是持久连接，则与 fetchStart 值相等
        // 注意如果在传输层发生了错误且重新建立连接，则这里显示的是新建立的连接开始的时间
        connectStart: window?.performance?.timing?.connectStart,
        // HTTP（TCP） 完成建立连接的时间（完成握手），如果是持久连接，则与 fetchStart 值相等
        // 注意如果在传输层发生了错误且重新建立连接，则这里显示的是新建立的连接完成的时间
        // 注意这里握手结束，包括安全连接建立完成、SOCKS 授权通过
        connectEnd: window?.performance?.timing?.connectEnd,
        // HTTPS 连接开始的时间，如果不是安全连接，则值为 0
        secureConnectionStart: window?.performance?.timing?.secureConnectionStart,
        // HTTP 请求读取真实文档开始的时间（完成建立连接），包括从本地读取缓存
        // 连接错误重连时，这里显示的也是新建立连接的时间
        requestStart: window?.performance?.timing?.requestStart,
        // HTTP 开始接收响应的时间（获取到第一个字节），包括从本地读取缓存
        responseStart: window?.performance?.timing?.responseStart,
        // HTTP 响应全部接收完成的时间（获取到最后一个字节），包括从本地读取缓存
        responseEnd: window?.performance?.timing?.responseEnd,
        // 开始解析渲染 DOM 树的时间，此时 Document.readyState 变为 loading
        // 并将抛出 readystatechange 相关事件
        domLoading: window?.performance?.timing?.domLoading,
        // 完成解析 DOM 树的时间，Document.readyState 变为 interactive，并将抛出 readystatechange 相关事件
        // 注意只是 DOM 树解析完成，这时候并没有开始加载网页内的资源
        domInteractive: window?.performance?.timing?.domInteractive,
        // DOM 解析完成后，网页内资源加载开始的时间 在 DOMContentLoaded 事件抛出前发生
        domContentLoadedEventStart: window?.performance?.timing?.domContentLoadedEventStart,
        // DOM 解析完成后，网页内资源加载完成的时间（如 JS 脚本加载执行完毕）
        domContentLoadedEventEnd: window?.performance?.timing?.domContentLoadedEventEnd,
        // DOM 树解析完成，且资源也准备就绪的时间，Document.readyState 变为 complete，并将抛出 readystatechange 相关事件
        domComplete: window?.performance?.timing?.domComplete,
        // load 事件发送给文档，也即 load 回调函数开始执行的时间注意如果没有绑定 load 事件，值为 0
        loadEventStart: window?.performance?.timing?.loadEventStart,
        // load 事件的回调函数执行完毕的时间
        loadEventEnd: window?.performance?.timing?.loadEventEnd,
      };
      dispatch(
        logging({
          category: 'R',
          action: 'PCSTORE_Performance',
          param2: param2,
        }),
      );
    }, 3000);
  }, []);

  // 启动事项  获取用户已购买的单机付费游戏, 因为依赖用户所以登录登出都得重新请求
  useEffect(() => {
    dispatch(getPayGamePayList());
    dispatch(getSubscribedAppList());
    if (!userInfo?.uid) {
      dispatch(emptySubscribedAppList());
    }
  }, [userInfo]);

  /********************** 主应用传入子应用 中的一些方法 *******************/
  useEffect(() => {
    window.mainHistory = () => history;
    window.mainGetLogInfoData = () => {
      return logInfoData;
    };
    window.mainSetLogInfoData = logInfo => {
      dispatch(logPostInfo(logInfo));
    };
    window.mainForumNotice = param => {
      if (param.type === 'softSubscribe') {
        // 软件预约的处理
        dispatch(getSubscribedAppList());
      }
      if (param.type === 'ForumUpdateSoftSubscribe') {
        // 软件预约通知酷软圈刷新的处理
        window.CallForumUpdateSoftSubscribe = param.mainCallForumFunc;
      }
    };
  }, [dispatch, history, logInfoData]);
  /*********************************************************************/

  // 初始化主题变换设置
  useEffect(() => {
    setTheme(AllStoreTheme[storeTheme]);
  }, [storeTheme]);

  useEffect(() => {
    cssVars({
      watch: true, // 当添加，删除或修改其<link>或<style>元素的禁用或href属性时，ponyfill将自行调用
      variables: theme, // variables 自定义属性名/值对的集合
      onlyLegacy: true, // false  默认将css变量编译为浏览器识别的css样式  true 当浏览器不支持css变量的时候将css变量编译为识别的css
    });
  }, [theme]);

  /**
   * 初始化中的一些设置
   */
  useEffect(() => {
    // 进入页面注册是否关闭快装功能
    const enabled = localStorage.getItem(cacheKeys.ENABLE_QUICK_INSTALL) || '1';
    const isEnabledSilent = enabled === '' || enabled === '1';
    dispatch(setIsEnabledSilent(isEnabledSilent));

    let timeoutIndex = setTimeout(() => {
      // 触发是否需要预下载模拟器
      PCStoreJsBridge.notifyPreDownloadSIM().then(res => {
        logNative(`触发是否需要预下载模拟器 调用结果 ${res}`);
      });
      // 用户评分
      const userScore = localStorage.getItem(cacheKeys.USER_SCORE_VISIBLE);
      setUserScoreVisible(!userScore || userScore === '');

      clearTimeout(timeoutIndex);
    }, 5 * 1000);
  }, []);

  /**
   * 壁纸下载任务管理
   * 下载任务完成之后的处理
   */
  const handleOpenFolder = useCallback(() => {
    try {
      PCStoreJsBridge.getWallpaperDPath().then(res => {
        PCStoreJsBridge.openFolder(res.workpath);
      });
      dispatch(
        logging({
          category: 'Wallpaper',
          action: 'C_Wallpaper_Openpath',
          param2: {
            source: logInfoData.source,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
          },
        }),
      );
    } catch (err) {
      logNative(`打开壁纸文件下载目录报错`);
    }
  }, []);

  const handleSuccToast = useCallback(() => {
    Toast.success({
      content: (
        <div className={styles.toast}>
          下载成功，
          <div onClick={handleOpenFolder} className={styles.openFolder}>
            打开下载目录查看
          </div>
        </div>
      ),
    });
  }, []);

  const handleFailToast = useCallback((num = 1) => {
    Toast.error({
      content: (
        <div className={styles.toast}>
          {num}张壁纸下载失败,
          <div onClick={handleOpenFolder} className={styles.openFolder}>
            打开下载目录查看
          </div>
        </div>
      ),
    });
  }, []);

  const setWallpaper = useCallback(
    param => {
      // 直接设置壁纸
      PCStoreJsBridge.wpSetWallpaper(param).then(ret2 => {
        if (ret2.succ === 'true') {
          Toast.success({
            content: '壁纸设置成功，请查看电脑桌面',
            // onClose: () => {
            //   // 判断是否是有快捷方式
            //   let localPath = location?.pathname || '';
            //   if (
            //     (localPath.indexOf('/wprecommend') > -1 ||
            //       localPath.indexOf('/wpmine/setup') > -1 ||
            //       localPath.indexOf('/wpcategory') > -1 ||
            //       localPath.indexOf('/wpdetail') > -1 ||
            //       localPath.indexOf('/wprank') > -1 ||
            //       localPath.indexOf('/wpauthordetail') > -1 ||
            //       localPath.indexOf('/wphot') > -1 ||
            //       localPath.indexOf('/wprankpage') > -1) &&
            //     !wpPreview.isShow
            //   ) {
            //     PCStoreJsBridge.checkWALLPAPERxits().then(res => {
            //       if (res.PIN) {
            //         if (!localGetItem('FIRST_WALLPAPER')) {
            //           dispatch(
            //             createShortcut({
            //               tag: true,
            //               loginInfo: logInfoData,
            //               wallpaperInfo: { wallpaperId: param.id },
            //             }),
            //           );
            //         }
            //       }
            //     });
            //   } else {
            //     localSetItem('FIRST_WALLPAPER', true);
            //   }
            // },
          });
          window.wpSettingWallpaperTaskList = window.wpSettingWallpaperTaskList.filter(
            item => param.id !== item.id,
          );
          // 去关闭轮播
          PCStoreJsBridge.switchWpOpenTurn({
            switch: 'off',
          }).then(res => {
            if (res) {
              if (
                window.PCStore_WpMine_TurnUpdate &&
                typeof window.PCStore_WpMine_TurnUpdate === 'function'
              ) {
                setTimeout(() => {
                  window.PCStore_WpMine_TurnUpdate();
                }, 100);
              }
              dispatch(
                logging({
                  category: 'Wallpaper',
                  action: 'R_Wallpaper_Loop_Stop',
                  label: '',
                  param2: {
                    source: logInfoData?.source,
                    source_p: logInfoData?.source_p,
                    source_pp: logInfoData?.source_pp,
                    Looptype: 2,
                  },
                }),
              );
            }
          });
        } else {
          Toast.error({
            content: '设置失败，请稍后再试！',
          });
        }
      });
    },
    [wpPreview, location],
  );

  const showPreviewWallpaper = useCallback(
    wp => {
      if (wpPreview && wpPreview.wallpaperId === wp.wallpaperId) {
        // 预览壁纸
        PCStoreJsBridge.wpMaximizeStroe().then(ret => {
          if (ret.succ) {
            dispatch(
              updatePreviewInfo({
                ...wpPreview,
                isShow: true,
                url: wp.path,
                wallpaperId: wp.wallpaperId,
                wallpaper: wp,
              }),
            );
          }
        });
      }
    },
    [wpPreview],
  );

  useEffect(() => {
    wpDowloadImgs.forEach((wp, i) => {
      if (wp.status === WP_DOWNLOAD_FINISHED) {
        if (wp.type === 'setWallpaper') {
          const param = { url: wp.wallpaperImg[2].uri, id: wp.wallpaperId };
          // 同时正在设置壁纸中的任务控制在三个以内
          if (!window.wpSettingWallpaperTaskList) {
            window.wpSettingWallpaperTaskList = [param];
            setWallpaper(param);
          } else if (
            window.wpSettingWallpaperTaskList &&
            window.wpSettingWallpaperTaskList.length < 3
          ) {
            const found = window.wpSettingWallpaperTaskList.find(wp => wp.id === param.id);
            if (!found) {
              window.wpSettingWallpaperTaskList.push(param);
              setWallpaper(param);
            }
          } else {
            Toast.error({
              content: '操作太频繁，请稍后再试！',
            });
          }
        } else if (wp.type === 'setPreview') {
          showPreviewWallpaper(wp);
        }
      } else if (wp.status === WP_DOWNLOAD_FAILED && wp.type?.indexOf('setWpDownload') < 0) {
        Toast.error({
          content: '操作失败，请重试！',
        });
      }
    });
  }, [wpDowloadImgs]);

  // 付费壁纸下载
  useEffect(() => {
    // status 0:等待 1下载中 2下载完成 3 下载失败
    // 找出付费壁纸
    const target = wpDowloadImgs?.filter(wp => {
      return wp?.type?.indexOf('setWpDownload') > -1 && wp?.status > -1;
    });
    const expectCount = Object.keys(wpPayDownCount).reduce((total, key) => {
      return +wpPayDownCount[key] + total;
    }, 0);
    if (target?.length > 0 && target?.length === expectCount) {
      const result = target.find(wp => [0, 1].indexOf(wp?.status) > -1);
      // 下载完成
      if (!result) {
        // 判断失败
        const fails = target.filter(wp => wp?.status === 3);
        if (fails && fails.length > 0) {
          handleFailToast(fails.length);
        } else {
          handleSuccToast();
        }
        // 下载完成打桩
        target.forEach(wp => {
          dispatch(
            logging({
              category: 'Wallpaper',
              action: 'R_Wallpaper_D_Ed',
              label: '',
              param2: {
                source: `${logInfoData.source}`,
                source_p: logInfoData.source_p,
                source_pp: logInfoData.source_pp,
                wptype: wp?.type?.indexOf('__') > -1 ? 2 : 1,
                wallpaperId: wp.wallpaperId,
                status: wp?.status === 3 ? 0 : 1,
                wallpaperCode: wp?.type?.split('__')?.[1],
              },
            }),
          );
        });
        dispatch(updateWpPayDownCount({ type: 'delete' }));
        target.forEach(wp => {
          dispatch(removeDownloadImg({ wallpaper: wp }));
        });
      }
    }
  }, [wpDowloadImgs, wpPayDownCount]);

  /**
   * 进入页面设置菜单是否展示小红点
   */
  useEffect(() => {
    const spotSoftStr = localStorage.getItem(mySoftKeys.RED_SPOT_SOFT) || '';
    const installedSpotSoft = installedSoft.find(
      softItem => softItem.androidType === '1' && spotSoftStr.indexOf(softItem.packageName) > -1,
    );
    dispatch(setMenuSpot(installedSpotSoft && installedSpotSoft.packageName));
  }, [dispatch, installedSoft]);

  // 移动窗口Mouse
  const handleWindowHtCaption = useCallback(ev => {
    ev.stopPropagation();
    if (ev.target instanceof HTMLAnchorElement || ev.target instanceof HTMLInputElement) {
      return;
    }
    PCStoreJsBridge.startMoveWindow();
  }, []);
  // 移动窗口触屏
  const handleTouchStart = useCallback(ev => {
    ev.stopPropagation();
    if (ev.target instanceof HTMLAnchorElement || ev.target instanceof HTMLInputElement) {
      return;
    }
    if (ev.targetTouches) {
      PCStoreJsBridge.touchStartWindow(ev.targetTouches[0]);
    } else {
      PCStoreJsBridge.touchStartWindow();
    }
  }, []);

  const handleTouchMove = useCallback(ev => {
    if (ev.targetTouches) {
      PCStoreJsBridge.touchMoveWindow(ev.targetTouches[0]);
    } else {
      PCStoreJsBridge.touchMoveWindow();
    }
  }, []);

  const handleTouchEnd = useCallback(ev => {
    PCStoreJsBridge.touchEndWindow();
  }, []);

  const doubleClickTopBar = useCallback(
    e => {
      if (!window.PcstoreCanChangeSize) {
        return;
      }
      if (!hasClass(e.target, 'empty')) {
        return;
      }
      if (isMaximize) {
        dispatch(setMaximize({ isMaximize: false }));
        PCStoreJsBridge.middleWindow();
      } else {
        dispatch(setMaximize({ isMaximize: true }));
        PCStoreJsBridge.maximizeWindow();
      }
      sessionStorage.setItem('PCStoreIsMaximize', isMaximize ? 0 : 1);
      dispatch(
        logging({
          category: 'C',
          action: 'DbClick_Bar',
          label: '',
          param2: {
            source: logInfoData.source,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            isMaximize: isMaximize ? 0 : 1,
          },
        }),
      );
    },
    [isMaximize],
  );

  const handleHidden = useCallback(ev => {
    dispatch(showAAppQRCode(false));
    dispatch(setDownloadVisible(false));
    dispatch(setOperationMenuVisible(false));
    if (!(ev.target instanceof HTMLInputElement)) {
      dispatch(setHotLenovoVisible(-1));
    }
  }, []);

  useEffect(() => {
    const pn = location.pathname.replace(`${CONTEXT}`, '');
    let currentMenu = pn.split('/')[1];

    if (currentMenu === 'game') {
      currentMenu += `/${pn.split('/')[2] || ''}`;
    }

    if (MENUS_CAN_BACK.indexOf(currentMenu) > -1) {
      dispatch(setCanBack(false));
    } else {
      dispatch(setCanBack(true));
    }
  }, [location.pathname]);

  const handleBack = useCallback(() => {
    if (canBack) {
      history.goBack();
    }
    dispatch(
      logPostInfo({
        source_p: logInfoData.source || 'back',
        source_pp: logInfoData.source_p,
      }),
    );
  }, [canBack]);

  /**
   * 处理VT状态，并写入token
   */
  useEffect(() => {
    // 获取是否支持TV模式。由于此组件中的useEffect，最先执行，所以在这里调用，要先于在App.js调用
    PCStoreJsBridge.getIsVTEabled().then(vtObj => {
      dispatch(updateIsVTEabled({ isVTEabled: vtObj.vt === true }));
      // 一进入商店更新localStorage中的vt值
      localStorage.setItem(cacheKeys.IS_VT_ENABLE, vtObj.vt === true ? 1 : 0);
      // 为了确保打桩时：machineInfo，commandLine有值，所以延时上报桩
      setTimeout(() => {
        dispatch(
          logging({
            category: 'Simulate',
            action: 'VT_Status',
            label: '',
            param2: {
              status: vtObj.vt === true ? '1' : '0',
              vtstatus: vtObj.vtstatus,
            },
          }),
        );
      }, 2000);
    });
  }, [dispatch]);

  // 在这里控制FirstRun
  useEffect(() => {
    if (firstRun) {
      dispatch(setFirstRun(false));
    }
  }, [firstRun]);
  /**
   * 根据命令，处理需要跳入的页面
   */
  useEffect(() => {
    if (!commandLine) {
      return;
    }
    // 管家进入
    if (commandLine.indexOf('-c pcm_main') > -1) {
      dispatch(setActiveMenu(`${CONTEXT}/`));
      history.replace(`${CONTEXT}/`);
    }
    // 管家--工具箱--软件升级
    if (commandLine.indexOf('-c pcm_toolbox_update') > -1) {
      dispatch(setActiveMenu(`${CONTEXT}/update`));
      history.push(`${CONTEXT}/update`);
    }
    // 管家--工具箱--软件卸载
    if (commandLine.indexOf('-c pcm_toolbox_uninstall') > -1) {
      dispatch(setActiveMenu(`${CONTEXT}/uninstall`));
      history.push(`${CONTEXT}/uninstall`);
    }
    // 管家-软件升级弹窗
    if (commandLine.indexOf('-c pcm_tanchuang') > -1) {
      dispatch(setActiveMenu(`${CONTEXT}/update`));
      history.push(`${CONTEXT}/update`);
    }
    // 开机
    if (commandLine.indexOf('-c pcm_tanchuang_kaiji') > -1) {
      const softID = commandLine.split('#')[1];
      const bizInfo = JSON.stringify({});
      if (softID) {
        history.push(`${CONTEXT}/detail/soft/${softID}/${bizInfo}`);
      }
    }
    // 管家--垃圾清理--软件卸载
    if (commandLine.indexOf('-c pcm_clean_uninstall') > -1) {
      dispatch(setActiveMenu(`${CONTEXT}/uninstall`));
      history.replace(`${CONTEXT}/uninstall`);
    }
    // 管家直接进入详情页 并且触发下载
    if (commandLine && commandLine.indexOf('-c pcm_security_install') > -1) {
      logNative(`命令行：管家直接进入详情页 并且触发下载 commandLine=${commandLine}`);
      const softID = commandLine.split('#')[1] || '';
      const bizId = commandLine.split('#')[2] || '';
      if (softID || bizId) {
        const bizInfo = JSON.stringify({ bizType: 'intercept', bizId: bizId.split(' ')[0] });
        history.replace(`${CONTEXT}/detail/soft/${softID}/${bizInfo}?isDownload=1`);
      }
    }
    // 隐式启动商店，并开始下载软件
    if (commandLine && commandLine.indexOf('-c pcm_hidden_install') > -1) {
      logNative(`命令行：隐式启动商店，并开始下载软件 commandLine=${commandLine}`);
      const softIds = getParamString('softIds', commandLine);
      const pns = getParamString('pns', commandLine);
      const bizId = getParamString('bizId', commandLine);
      const bizType = getParamString('bizType', commandLine);
      let bizInfo = '{}';
      if (bizId && bizType) {
        bizInfo = JSON.stringify({ bizType, bizId });
      }

      // 只要有值就带上bizInfo
      // 默认地址
      const defaultPage = getDefaultPage();
      if (softIds || pns || bizId || bizType) {
        history.replace(`${CONTEXT}/recommend?softIds=${softIds}&pns=${pns}&bizInfo=${bizInfo}`);
      } else {
        history.replace(`${defaultPage}`);
      }
    }

    // 调起商店，并跳入某个页面
    if (commandLine && commandLine.indexOf('-c open_page') > -1) {
      const pages = [
        'recommend',
        'education',
        'edurecommend',
        'educategory',
        'edumine',
        'edudetail',
        'work',
        // 'discover',
        'topn',
        'game',
        'shop',
        'update',
        'uninstall',
        'category',
        'detail',
        'search',
        'guesslikesmore',
        'topnmore',
        'androidrecommend',
        'androidcategory',
        'androiddetail',
        'special',
        'speciallist',
        'wpdetail',
        'wprecommend',
        'wpcategory',
        'wpmine',
        'wpzt',
        'wprank',
        'forumlist',
        'forumlistmine',
        'forumdetail',
        'otherpage',
        // 'discover',
        'message',
        'install_by_version',
        'softrank',
        'setting',
        'discount',
        'downloadlist',
      ];
      const page = getParamString('page', commandLine);
      const defaultPage = getDefaultPage();
      logNative(`命令行：调起商店，并跳入某个页面 commandLine=${commandLine} page:${page}`);
      if (page && pages.indexOf(page) > -1) {
        if (page === 'install_by_version') {
          // 支持下载多个软件，并且支持下载每个软件的指定版本（PC，安卓都支持）
          try {
            const softsJSONStr = window.atob(getParamString('softs', commandLine) || '');
            const softs = JSON.parse(softsJSONStr);
          } catch (err) {
            logNative(
              `命令行：调起商店 install_by_version, 解析失败 ${getParamString(
                'softs',
                commandLine,
              )}`,
            );
          }
          history.push(`${defaultPage}?commandPage=${page}`);
        } else if (page === 'recommend') {
          const softIds = getParamString('softIds', commandLine);
          const pns = getParamString('pns', commandLine);
          const bizId = getParamString('bizId', commandLine);
          const bizType = getParamString('bizType', commandLine);
          const openSetting = getParamString('openSetting', commandLine);
          const focusSearch = getParamString('focusSearch', commandLine);
          const filetype = getParamString('filetype', commandLine) ?? '';
          const type = getParamString('type', commandLine) ?? '';
          const boxTag = getParamString('boxTag', commandLine) ?? '';
          let bizInfo = '{}';
          if (bizId || bizType) {
            bizInfo = JSON.stringify({ bizType, bizId });
          }

          // 进入默认首页
          if (openSetting === '1') {
            // dispatch(setDownloadPathVisible(true));
            // history.push(defaultPage);
            history.push(`${CONTEXT}/setting?filetype=${filetype}&type=${type}`);
            return;
          }

          // 进入默认首页
          if (focusSearch === '1') {
            dispatch(setHotLenovoVisible(0));
            history.push(defaultPage);
            return;
          }

          // 只要有值就带上bizInfo
          if (softIds || pns) {
            history.replace(`${CONTEXT}/${page}?softIds=${softIds}&pns=${pns}&bizInfo=${bizInfo}`);
          } else {
            history.push(`${CONTEXT}/recommend`);
          }

          // 弹出问题反馈弹窗标识
          if (boxTag) {
            history.push(`${CONTEXT}/recommend?boxTag=${boxTag}`);
          }
        } else if (page === 'discover') {
          // history.push(`${CONTEXT}/${page}`);
        } else if (page === 'category') {
          const code = getParamString('code', commandLine) || 'soft';
          const classId = getParamString('classId', commandLine) || '-1';
          const tagId = getParamString('tagId', commandLine) || '-1';
          history.push(`${CONTEXT}/${page}?code=${code}&classId=${classId}&tagId=${tagId}`);
        } else if (page === 'edurecommend') {
          history.push(`${CONTEXT}/education/`);
        } else if (page === 'educategory') {
          const gradeId = getParamString('gradeId', commandLine) || '';
          const subjectId = getParamString('subjectId', commandLine) || '';
          const phaseId = getParamString('phaseId', commandLine) || '';
          history.push(
            `${CONTEXT}/education/category?gradeId=${gradeId}&subjectId=${subjectId}&phaseId=${phaseId}`,
          );
        } else if (page === 'edumine') {
          const tag = getParamString('tag', commandLine) || 'course';
          history.push(`${CONTEXT}/education/mine?tag=${tag}`);
        } else if (page === 'edudetail') {
          const courseId = getParamString('courseId', commandLine) || '';
          const studyState = getParamString('studyState', commandLine) || '0';
          const bizId = getParamString('bizId', commandLine) || '';
          const bizType = getParamString('bizType', commandLine) || '';
          history.push(
            `${CONTEXT}/edudetail?courseId=${courseId}&studyState=${studyState}&bizInfo=${{
              bizId,
              bizType,
            }}`,
          );
        } else if (page === 'search') {
          const keyword = getParamString3('keyword', commandLine) || '';
          const activeTab = getParamString('activeTab', commandLine) || '';
          const filetype = getParamString('filetype', commandLine) ?? '';
          const type = getParamString('type', commandLine) ?? '';
          history.push(
            `${CONTEXT}/searchresult?keyword=${keyword}&activeTab=${activeTab}&filetype=${filetype}&type=${type}`,
          );
        } else if (page === 'game') {
          history.push(`${CONTEXT}/game/`);
        } else if (page === 'topnmore') {
          const code = getParamString('code', commandLine);
          const title = getParamString('title', commandLine);
          history.push(`${CONTEXT}/${page}/${code}/${title}`);
        } else if (page === 'update') {
          const softIds = getParamString('softIds', commandLine);
          const pns = getParamString('pns', commandLine);
          const sdkExt = getParamString('sdkExt', commandLine);
          const bizId = getParamString('bizId', commandLine) || '';
          const bizType = getParamString('bizType', commandLine) || '';
          history.push(
            `${CONTEXT}/${page}?softIds=${softIds}&pns=${pns}&bizId=${bizId}&bizType=${bizType}&sdkExt=${sdkExt}`,
          );
        } else if (page === 'detail') {
          const softID = getParamString('softId', commandLine);
          const isDownload = getParamString('isDownload', commandLine) || '0';
          const bizId = getParamString('bizId', commandLine) || '';
          const bizType = getParamString('bizType', commandLine) || '';
          const bizInfoStr = getParamString('bizInfo', commandLine) || '{}';
          const filetype = getParamString('filetype', commandLine) ?? '';
          const type = getParamString('type', commandLine) ?? '';
          const comment = getParamString('comment', commandLine) ?? '';
          const score = getParamString('score', commandLine) ?? '';
          let bizInfo = bizInfoStr;
          if (bizId || bizType) {
            bizInfo = JSON.stringify({ bizType, bizId });
          }
          history.push(
            `${CONTEXT}/${page}/soft/${softID}/${bizInfo}?isDownload=${isDownload}&filetype=${filetype}&type=${type}&comment=${comment}&score=${score}`,
          );
        } else if (page === 'androidrecommend') {
          history.push(`${CONTEXT}/android/recommend`);
        } else if (page === 'androidcategory') {
          const code = getParamString('code', commandLine) || 'soft';
          history.push(`${CONTEXT}/android/category?code=${code}`);
        } else if (page === 'androiddetail') {
          const pn = getParamString('pn', commandLine);
          const vc = getParamString('vc', commandLine) || 0;
          const bizId = getParamString('bizId', commandLine);
          const bizType = getParamString('bizType', commandLine);
          const isDownload = getParamString('isDownload', commandLine) || '0';
          const bizInfoStr = getParamString('bizInfo', commandLine) || '{}';
          let bizInfo = bizInfoStr;
          if (bizId && bizType) {
            bizInfo = JSON.stringify({ bizType, bizId });
          }
          history.push(`${CONTEXT}/adetail/${pn}/${vc}/${bizInfo}?isDownload=${isDownload}`);
        } else if (page === 'special') {
          const ztId = getParamString('ztId', commandLine) || '1';
          const bannerId = 'outside';
          history.push(`${CONTEXT}/special?ztId=${ztId}&bannerId=${bannerId}`);
        } else if (page === 'speciallist') {
          history.push(`${CONTEXT}/speciallist`);
        } else if (page === 'wpdetail') {
          const wallpaperId = getParamString('wallpaperId', commandLine) || '1';
          const pageTage = getParamString('pageTage', commandLine) || 'collect';
          history.push(
            `${CONTEXT}/wpdetail?wallpaperId=${wallpaperId}&pageSource=screen&tagId=${pageTage}`,
          );
        } else if (page === 'wprecommend') {
          history.push(`${CONTEXT}/wallpaper/wprecommend`);
        } else if (page === 'wpcategory') {
          const classId = getParamString('classId', commandLine) || '-1';
          const tagId = getParamString('tagId', commandLine) || '-1';
          const colorId = getParamString('colorId', commandLine) || '-1';
          history.push(
            `${CONTEXT}/wallpaper/wpcategory/?classId=${classId}&tagId=${tagId}&colorId=${colorId}`,
          );
        } else if (page === 'wpmine') {
          const tagId = getParamString('tagId', commandLine) || 'collect';
          history.push(`${CONTEXT}/wallpaper/wpmine/${tagId}`);
        } else if (page === 'wpzt') {
          const wpZtId = getParamString('wpZtId', commandLine);
          history.push(`${CONTEXT}/wpzt?wpZtId=${wpZtId}`);
        } else if (page === 'wprank') {
          const code = getParamString('code', commandLine);
          history.push(`${CONTEXT}/wprank?code=${code}`);
        } else if (page === 'uninstall') {
          const lnkTarget = getParamString2('lnkTarget', commandLine) || '';
          const tag = getParamString2('tag', commandLine) || ''; // 'residual' || 'not_often_used_softs';
          const softguid = getParamString3('softguid', commandLine) ?? '';
          const isx64 = getParamString2('isx64', commandLine) ?? '';
          history.push(
            `${CONTEXT}/uninstall?lnkTarget=${lnkTarget}&tag=${tag}&softguid=${softguid}&isx64=${isx64}`,
          );
        } else if (page === 'otherpage') {
          const url = getParamString2('url', commandLine) || '';
          history.push(`${CONTEXT}/otherpage?url=${url}`);
        } else if (page === 'forumlist') {
          const bizId = getParamString('bizId', commandLine);
          const bizType = getParamString('bizType', commandLine);
          const bizInfoStr = getParamString('bizInfo', commandLine) || '{}';
          let bizInfo = bizInfoStr;
          if (bizId && bizType) {
            bizInfo = JSON.stringify({ bizType, bizId });
            history.push(`${CONTEXT}${MICROCONTEXT}${MICROCONTEXT}/forumlist?bizInfo=${bizInfo}`);
          }
          const classId = getParamString('classId', commandLine);
          if (classId) {
            history.push(`${CONTEXT}${MICROCONTEXT}${MICROCONTEXT}/forumlist?classId=${classId}`);
          }
        } else if (page === 'forumlistmine') {
          const classify = getParamString('classify', commandLine);
          history.push(`${CONTEXT}${MICROCONTEXT}${MICROCONTEXT}/${classify}`);
        } else if (page === 'forumdetail') {
          const id = getParamString('id', commandLine);
          const bizId = getParamString('bizId', commandLine);
          const bizType = getParamString('bizType', commandLine);
          const bizInfoStr = getParamString('bizInfo', commandLine) || '{}';
          let bizInfo = bizInfoStr;
          if (bizId && bizType) {
            bizInfo = JSON.stringify({ bizType, bizId });
          }
          history.push(
            `${CONTEXT}${MICROCONTEXT}${MICROCONTEXT}/forumdetail?id=${id}&bizInfo=${bizInfo}`,
          );
        } else if (page === 'message') {
          const tab = getParamString('tab', commandLine);

          dispatch(setMessageVisible(true));

          history.push(`${defaultPage}?tab=${tab}`);
        } else if (page === 'softrank') {
          const code = getParamString2('code', commandLine) || '';
          const source_detail = 'commandLine';
          history.push(`${CONTEXT}/rankmore?code=${code}&source_detail=${source_detail}`);
        } else if (page === 'setting') {
          const filetype = getParamString('filetype', commandLine) ?? '';
          const type = getParamString('type', commandLine) ?? '';
          const more = getParamString('more', commandLine) ?? '';
          history.push(`${CONTEXT}/setting?filetype=${filetype}&type=${type}&more=${more}`);
        } else if (page === 'discount') {
          const tag = getParamString('tag', commandLine) ?? '';
          history.push(`${CONTEXT}/discount?tag=${tag}`);
        } else if (page === 'downloadlist') {
          dispatch(setDownloadVisible(true));
          history.replace(defaultPage);
        } else {
          history.replace(defaultPage);
        }
      }
    }
  }, [dispatch, commandLine]);

  /**
   * 8.3 根据命令，处理需要下载的软件
   * 支持下载多个软件，
   * 并且支持下载每个软件的指定版本（PC，安卓都支持）,
   * 加一个sessionId 用于判断是否重复下载
   */
  useEffect(() => {
    if (commandLine && commandLine?.indexOf('install_by_version') > -1) {
      const softsString = getParamString('softs', commandLine);
      if (
        !window?.PAGE_COMMANDLINE_GET_SOTF_LIST ||
        window?.PAGE_COMMANDLINE_GET_SOTF_LIST !== softsString
      ) {
        // 将softsString window 用于判断是否重复调用此命令行
        window.PAGE_COMMANDLINE_GET_SOTF_LIST = softsString;
        //
        dispatch(getSoftInfosByVersion({ commandLine, sessionId: softsString }));
      }
    }
  }, [dispatch, commandLine]);

  /**
   * 8.3 根据请求回来需要下载的软件，开始组装数据并且触发下载
   */
  useEffect(() => {
    if (
      softInfosVersion &&
      softInfosVersion?.data?.length > 0 &&
      (!window?.PAGE_COMMANDLINE_ADD_SOTF_LIST ||
        window?.PAGE_COMMANDLINE_ADD_SOTF_LIST !== softInfosVersion?.sessionId) &&
      silentInstSoft &&
      silentInstSoft.length >= 0 &&
      upgradeSofts &&
      upgradeSofts.length != undefined
    ) {
      // 将softsString window 用于判断是否重复调用此命令行
      window.PAGE_COMMANDLINE_ADD_SOTF_LIST = softInfosVersion?.sessionId;
      addSoftListToDownload();
    }
  }, [dispatch, softInfosVersion, upgradeSofts, silentInstSoft]);

  // 添加下载任务
  const addSoftListToDownload = useCallback(() => {
    const isEnabledSilent = localStorage.getItem(cacheKeys.ENABLE_QUICK_INSTALL) || '1';
    const androidSoftList = [];
    const pcSoftList = [];
    softInfosVersion.data.forEach(softItem => {
      const upgrade = upgradeSofts.find(
        soft_ =>
          (soft_.androidType !== '1' &&
            (soft_.softID === softItem.softID || soft_.SoftID === softItem.softID)) ||
          (soft_.androidType === '1' && soft_.packageName === softItem.packageName),
      );
      if (softItem && softItem.androidType === '1') {
        const logParam2 = {
          source: 'Reco',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          softid: softItem.packageName,
          softName: softItem.softName,
          packageName: softItem.packageName,
          versionCode: softItem.versionCode,
          softType: '1',
          type: upgrade ? 'u' : 'd',
          url: softItem.downLoadUrl || softItem.downloadUrl,
        };
        androidSoftList.push({
          ...softItem,
          logInfo: logParam2,
          bizInfo: softInfosVersion.bizInfo,
        });
      } else {
        const installparams = {};
        const logParam2 = {
          source: 'Reco',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          softid: softItem.softID,
          softName: softItem.softName,
          softType: '0',
          type: upgrade ? 'u' : 'd',
          url: softItem.downLoadUrl || softItem.downloadUrl,
        };

        if (silentInstSoft && isEnabledSilent) {
          const silentSoft = silentInstSoft.find(soft_ => soft_.softID === softItem.softID);
          if (silentSoft && silentSoft.softID) {
            logParam2.type = upgrade ? 'xu' : 'xd';
            if (silentSoft.silentParamDic) {
              installparams.quiet = silentSoft.silentParamDic;
            }
            if (silentSoft.silentDirParamDic) {
              installparams.todir = silentSoft.silentDirParamDic;
            }
          }
        }
        pcSoftList.push({
          ...softItem,
          logInfo: logParam2,
          installparams,
          bizInfo: softInfosVersion.bizInfo,
        });
      }
    });
    if (pcSoftList.length > 0 || androidSoftList.length > 0) {
      dispatch(downloadAddSoftList([...pcSoftList, ...androidSoftList]));
    }
  }, [dispatch, softInfosVersion, logInfoData, upgradeSofts, silentInstSoft, location]);

  /**
   * 注册键盘事件, 打开另一个商店窗口
   * ctrl + alt + o + p
   */
  useEffect(() => {
    document.onkeydown = function (event) {
      const ev = event || window.event;
      if (ev.code === 'KeyO' && ev.ctrlKey && ev.shiftKey && ev.altKey) {
        PCStoreJsBridge.openOtherStore({
          width: '1060',
          height: '750',
          dbgUrlBar: true,
        });
      }
      if (ev.code === 'ArrowDown') {
        let pagescroll = document.querySelector('div[pagescroll=PCStore_Page_Scroll]');
        if (pagescroll) {
          pagescroll.scrollTop += 10;
        }
      } else if (ev.code === 'ArrowUp') {
        let pagescroll = document.querySelector('div[pagescroll=PCStore_Page_Scroll]');
        if (pagescroll) {
          pagescroll.scrollTop -= 10;
        }
      }
    };

    window.addEventListener('resize', handleResize, false);
    handleResize();
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const handleResize = useCallback(
    debounce(e => {
      dispatch(
        changeWindowSize({
          width:
            window.outerWidth < 1060 ? 1060 : window.outerWidth > 1960 ? 1960 : window.outerWidth,
          height: window.outerHeight,
        }),
      );
    }, 20),
    [],
  );

  // 判断是否为外部调起
  const skipOtherPage = () => {
    let skip = false;
    // 管家直接进入详情页 并且触发下载
    if (commandLine && commandLine.indexOf('-c pcm_security_install') > -1) {
      const softID = commandLine.split('#')[1] || '';
      const bizId = commandLine.split('#')[2] || '';
      if (softID || bizId) {
        skip = true;
      }
    }
    const params = [
      '-c pcm_toolbox_update',
      '-c pcm_toolbox_uninstall',
      '-c pcm_tanchuang',
      '-c pcm_clean_uninstall',
      '-c pcm_hidden_install',
    ];

    // 调起商店，并跳入某个页面
    if (commandLine && params.find(item => commandLine.indexOf(item) > -1)) {
      skip = true;
    }
    if (commandLine && commandLine.indexOf('-c open_page') > -1) {
      const page = getParamString('page', commandLine);
      const defaultPage = getDefaultPage();
      // 不为默认页面的时候，且目标页面也不是指向默认页面
      if (page !== '' && defaultPage.indexOf(page) === -1) {
        skip = true;
      }
    }
    return skip;
  };

  /**
   * 判断欢迎页是否已经被弹出
   */
  useEffect(() => {
    const HistoryLen = (history && history.length) || 0;
    // 首次·掉起商店跳入其他页面 不显示
    if (!commandLine || (HistoryLen < 2 && skipOtherPage())) {
      return;
    }
    // if (HistoryLen < 2 && nowTime - popTime) {
    if (HistoryLen < 2) {
      setWelcome(true);
    } else {
      setWelcome(false);
    }
    setIsChooseWelcome(localStorage.getItem('SET_WELCOME_DIALOG') === 'true' ? true : false);
  }, [commandLine, history, isChooseWelcome]);

  useEffect(() => {
    if (welcomeData && welcomeData.tags) {
      let loaded = 0;
      welcomeData.tags.forEach((item, index) => {
        if (index < 4) {
          const imgs1 = new Image();
          imgs1.src = item.noSelectIcon;
          imgs1.onload = e => {
            loaded += 1;
            if (loaded >= 3) {
              setWelcomeLoadImg(true);
            }
          };
        }
      });
    }
  }, [welcomeData]);

  // 点击热搜框之外部分 弹窗消失 为缓存元素添加事件
  const hiddenHotSearch = () => {
    dispatch(setIsSearchClick(false));
    // 加了缓存之后click事件不能正确冒泡   所以这样手动监听点击事件
    dispatch(showAAppQRCode(false));
    dispatch(setDownloadVisible(false));
    dispatch(setOperationMenuVisible(false));
  };

  useEffect(() => {
    const target = document.getElementsByClassName('ka-wrapper');
    if (cachEL && cachEL.current) {
      cachEL.current.removeEventListener('click', hiddenHotSearch);
    }
    if (target && target[0]) {
      // eslint-disable-next-line prefer-destructuring
      cachEL.current = target[0];
      target[0].addEventListener('click', hiddenHotSearch);
    }
  }, [location]);

  return (
    <div
      className={`${styles.layout}`}
      onClick={handleHidden}
      onClickCapture={() => {
        dispatch(setIsSearchClick(false));
      }}
    >
      <div className="nav">
        <div className="nav_rgba" />
        <div
          className="logo"
          onMouseDown={handleWindowHtCaption}
          onTouchStart={handleTouchStart}
          onTouchMove={handleTouchMove}
          onTouchEnd={handleTouchEnd}
        />
        <Menu />
      </div>
      <div className="main">
        <div
          className={`empty ${topImgVideo?.visible ? 'top_bar_white' : 'top_bar'}`}
          onMouseDown={handleWindowHtCaption}
          onTouchStart={handleTouchStart}
          onTouchMove={handleTouchMove}
          onTouchEnd={handleTouchEnd}
          onDoubleClick={doubleClickTopBar}
        >
          <span
            className={
              canBack ? 'back iconfont icon-opt_back canback' : 'back iconfont icon-opt_back gray'
            }
            onClick={handleBack}
          />
          <Search />
          <AIGCInit />

          <div className={'empty'} />
          <Operation />
          <div style={{ display: downloadVisible ? 'block' : 'none' }}>
            <DownloadTask />
          </div>
        </div>

        <div
          id="apps"
          className="content_sub"
          style={{
            visibility: location.pathname.indexOf('forum') > -1 ? 'visible' : 'hidden',
            // 100的值为了让头部浮层能出来，不被页面内容覆盖，并且页面内容不被头部内容在上面
            zIndex: location.pathname.indexOf('forum') > -1 ? 100 : 0,
          }}
        />

        {online ? (
          <div
            className="content"
            id="container_content"
            style={{
              visibility: location.pathname.indexOf('forum') > -1 ? 'hidden' : 'visible',
              overflowY:
                location?.pathname.indexOf(`${CONTEXT}/special`) > -1 ||
                location?.pathname.indexOf(`${CONTEXT}/detail`) > -1 ||
                location?.pathname.indexOf(`${CONTEXT}/adetail`) > -1
                  ? 'visible'
                  : 'hidden',
            }}
            ref={containerRef}
          >
            {children}
          </div>
        ) : (
          <NoNet />
        )}
      </div>
      {AboutVisible && <About />}
      {OperationMenuVisible && <OperationMenu />}
      {pinPopVisible && <PinPop />}
      {pinPopCloseVisible && <PinPopClose />}
      {cleanToDStore && <PinPopToDStore />}
      {checkUpdateVisible && <CheckUpdate />}
      {wallpaperInfo.tag && !pinPopVisible && <WallpaperShortcut />}
      {/*
        模拟器等待提示弹框
        模拟器未启动点击卸载不弹出弹框（判断条件：1.卸载为空，2.或者卸载不为空并且有下载时弹出）
      */}
      {SIMStatus !== SIM_PREPARING &&
        SIM_STATUS_POP_SHOW.indexOf(SIMStatus) > -1 &&
        (uninstallSoft.length === 0 ||
          (uninstallSoft.length > 0 && downloadSoftDatas.length > 0)) && <SIMPop />}
      {SIMPopupInfo && <SimPopup />}
      {downloadPathVisible && <Setting />}
      {phoneVisible && <PhoneQRcode />}
      {inTimeInstSoft && inTimeInstSoft.appInfo && <InstDonePop />}
      {wpPreview && wpPreview.isShow && wpPreview.wallpaperId && <WpPreview />}
      {iframeInfo && iframeInfo.visible && <Iframe />}
      {detailCommentInfo && detailCommentInfo.visible === true && <DetailCommentDialog />}
      {releaseNotesVisible && <ReleaseNotes />}
      {userFeedbackVisible && <UserFeedback />}
      {userScoreVisible &&
        +new Date() > +new Date('2021-03-8 14:00:00') &&
        +new Date() < +new Date('2021-04-11 14:00:00') && <UserScore />}
      {shareVisible && <Share />}
      {fasterProductVisible && <FasterProduct />}
      {messageVisible && <Message />}
      {/* {(localGetItem('SET_WELCOME_DIALOG') === 'true' ? true : false) &&
        welcome &&
        welcomeData &&
        welcomeData.needShow &&
        !welcomeInit &&
        welcomeLoadImg && <Welcome />} */}
      {welcome &&
        !welcomeInit &&
        welcomeLoadImg &&
        (!localGetItem('WELCOME_SHOW_88') || localGetItem('WELCOME_SHOW_88') === '2') && (
          <Welcome />
        )}
      {<UserSurvey />}
      {btnPayAnti && btnPayAnti?.soft?.softID && btnPayAnti?.show && <ButtonPayAntiInfo />}
      {btnPayOrder && btnPayOrder?.soft?.softID && btnPayOrder?.show && <ButtonPayOrder />}
      {btnPayAntiErr && btnPayAntiErr?.soft?.softID && btnPayAntiErr?.show && <ButtonPayAnti />}
      <WpTurnIndex />
      {/* 下载路径不存在弹框，在关闭的一分钟内不再弹出 */}
      {showFileError?.show && +new Date() - showFileError?.time > 60 * 1000 && <DownloadFile />}
      {showSIM && (showSIM === `SIM_64` || showSIM === `SIM_Need_Restart`) && <DownloadSIM />}
      {subscribeSuccVisible?.isShow && <SubscribeSuccess />}
      {cancelShow?.isShow && <SubscribeCancel />}
      {noLoginSub?.isShow && <NoLoginSubscribe />}
      {openFailSoft?.isShow && <SoftOpenFail />}
      {/*壁纸兑换码弹窗*/}
      {wpExchangeShow && <WpExchange />}
      {/*壁纸兑换码结果弹窗*/}
      {wpExchangeResult?.isShow && <WpExchangeResult />}
      {/*删除安卓准备中的任务弹窗*/}
      {canenlDownShow.isShow && <CancelDownload />}
      {selectAIGCShow?.show && <AIGC></AIGC>}

      {/* 游戏cdk购买弹框 */}
      {gamecdkVisible?.isShow && <Gamecdk />}
      {/* 游戏cdk展示cdk弹框*/}
      {gamecdkCodeShow?.isShow && gamecdkCodeShow?.exchangeUrl && <GamecdkShow />}
      {storeTrayVisiable?.isShow && <PinPopTray />}
    </div>
  );
}

export default memo(Index);
